import React from 'react';
import './footer.css';
import { AiOutlineCopyright } from 'react-icons/ai';

function Footer() {
    return (
        <div className="footer">
           <AiOutlineCopyright /> Jared Loveridge | 2021
        </div>
    )
}

export default Footer
